import React from 'react';
import { useTranslation } from 'react-i18next';

import { subscribeToVersionMismatch } from '../../../services/client-version/version-mismatch-events';
import { useToaster } from '../../state/toaster-state';

/**
 * Renders nothing on its own. Subscribes to client/backend version-mismatch
 * events from the shared axios response interceptor (triggered by the
 * `X-Skymap-Client-Stale: 1` response header — see SK-5052 / SK-7015) and shows a
 * non-dismissible toast prompting the user to reload the page.
 *
 * Mounted inside ToasterState so it has access to {@link useToaster}.
 */
export const VersionMismatchToast = (): null => {
  const { t } = useTranslation('common');
  const { showToast } = useToaster();

  React.useEffect(() => {
    return subscribeToVersionMismatch(() => {
      showToast({
        id: 'client-version-mismatch',
        type: 'warning',
        title: t('version.mismatch.title', { ns: 'common' }),
        message: t('version.mismatch.message', { ns: 'common' }),
        duration: 0,
        dismissible: false,
        action: {
          label: t('version.mismatch.reload', { ns: 'common' }),
          onClick: () => {
            window.location.reload();
          },
        },
      });
    });
  }, [showToast, t]);

  return null;
};
